var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "lucky-cards-wrap"
  }, [_c('v-row', {
    staticClass: "lucky-cards-list"
  }, [_c('v-col', {
    staticClass: "lucky-cards-list__item",
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "lucky-card",
    attrs: {
      "flat": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clover
    }
  })], 1), _c('v-col', {
    staticClass: "lucky-cards-list__item",
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "lucky-card",
    attrs: {
      "flat": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clover
    }
  })], 1), _c('v-col', {
    staticClass: "lucky-cards-list__item",
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "lucky-card",
    attrs: {
      "flat": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clover
    }
  })], 1), _c('v-col', {
    staticClass: "lucky-cards-list__item",
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "lucky-card",
    attrs: {
      "flat": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clover
    }
  })], 1), _c('v-col', {
    staticClass: "lucky-cards-list__item",
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "lucky-card",
    attrs: {
      "flat": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clover
    }
  })], 1), _c('v-col', {
    staticClass: "lucky-cards-list__item",
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "lucky-card",
    attrs: {
      "flat": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.clover
    }
  })], 1)], 1), _c('CardDialog', {
    ref: "cardDialog"
  }), _c('AlreadyDialog', {
    ref: "alreadyDialog"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }